'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  padding: 2rem;\n'], ['\n  padding: 2rem;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject);

var TermsOfService = function (_Component) {
  _inherits(TermsOfService, _Component);

  function TermsOfService() {
    _classCallCheck(this, TermsOfService);

    return _possibleConstructorReturn(this, (TermsOfService.__proto__ || Object.getPrototypeOf(TermsOfService)).apply(this, arguments));
  }

  _createClass(TermsOfService, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        Wrapper,
        null,
        _react2.default.createElement(
          'h1',
          null,
          'Terms of Service'
        ),
        _react2.default.createElement(
          'strong',
          null,
          'Updated 1/14/2018'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The ',
          this.props.name,
          ' [the Show] is a virtual outdoor sports exhibition you can attend on any computer or mobile device. This page describes the terms and conditions of utilizing this service.  ',
          _react2.default.createElement(
            'b',
            null,
            'Any use of this service will constitute acceptance of these terms and conditions'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Using the Show requires creating an account.  What information is collected and how it is used is covered in our ',
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/privacy' },
            'Privacy Policy'
          ),
          '.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The Show and its components are offered for informational purposes only; this Show shall not be responsible or liable for the accuracy, usefulness or availability of any information transmitted or made available via the Show, and shall not be responsible or liable for any error or omissions in that information.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The Show and its original content, features, and functionality are owned by Vexpo Shows and/or individual exhibitors in the show and are protected by international copyright, trademark, patent, trade secret, and other intellectual property or proprietary rights laws.'
        ),
        _react2.default.createElement(
          'p',
          null,
          'The Show represents significant work and intellectual investment by a dedicated group. We ask that you respect that.  By using the show, you agree not to reverse engineer, decompile, disassemble or otherwise attempt to derive the source code, techniques, processes, algorithms, know-how or other information from the HTML, JavaScript, and CSS source code, or permit or induce others to do so.'
        ),
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: '/' },
          'Back to the ',
          this.props.name
        )
      );
    }
  }]);

  return TermsOfService;
}(_react.Component);

exports.default = TermsOfService;


//////////////////
// WEBPACK FOOTER
// ../vexpo-components/build/terms-of-service/terms-of-service.js
// module id = 1095
// module chunks = 0